export const environment = {
  production: false,
  apiURL: 'https://stgbracwash.brac.net',
  envName: 'stage',
  beneficiaryInfoFormId: 'dc682dbb-5460-42a9-8df9-e9ef0848031b',
  firebase: {
    apiKey: "AIzaSyDOi_mRVkFsfSlsAGtR9eUhZXNvthEU2tE",
    authDomain: "wash-3ee73.firebaseapp.com",
    projectId: "wash-3ee73",
    storageBucket: "wash-3ee73.firebasestorage.app",
    messagingSenderId: "606040644314",
    appId: "1:606040644314:web:ff36522614e5018a5b23e3",
    measurementId: "G-0RFLD1FS0S",
    vapidKey: "BK0g2NJo_T3S0O5AXnbZPgS4KsQYIA_kZcUFTR2iLhjjli8P9qbpcE8_1IaRzi6D46KifhdL_CXkIN5WaA3Uv9g"
  },
};
